<template>
  <div class="step_header">
    <div class="step_title form_title">
      <h3>Ви заповнили {{load}} заявки</h3>
    </div>
    <div class="form_progress">
      <div class="form_progress-load" :style="proggress()"></div>
    </div>

  </div>

</template>

<script>
    export default {
        name: "form-header",
        props: [
          'load'
        ],
        data(){
            return {}
        },
        methods:{
            proggress(){
               return "width: " +  this.load;
            }
        }
    }
</script>
